export default class InPageNavigator {
    constructor() {
        this.init();
    }

    init() {
        // Let browser restore last scroll if no hash
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'auto';
        }

        this.clickEvents();
        this.handleInitialHash();
        this.handlePopState();
    }

    scrollToHash(hash) {
        if (!hash || hash === '#') return;

        const $target = $(hash);
        if ($target.length === 0) return;

        const offset = $('.header-wrapper').outerHeight() || 0;
        const targetTop = $target[0].getBoundingClientRect().top + window.pageYOffset;
        const scrollTop = targetTop - offset;

        requestAnimationFrame(() => {
            window.scrollTo({ top: scrollTop, behavior: 'smooth' });
        });
    }

    navigateToHash(hash, push = true) {
        if (!hash || hash === '#') return;

        if (push && location.hash !== hash) {
            history.pushState(null, '', hash);
        }

        this.scrollToHash(hash);
    }

    clickEvents() {
        $('.inpagelinks a[href^="#"]').on('click', (e) => {
            e.preventDefault();
            const hash = e.currentTarget.getAttribute('href');
            this.navigateToHash(hash, true);
        });
    }

    handlePopState() {
        window.addEventListener('popstate', () => {
            if (location.hash) {
                this.scrollToHash(location.hash);
            }
            // If no hash, let the browser handle restoring scroll naturally
        });
    }

    handleInitialHash() {
        if (location.hash) {
            window.addEventListener('load', () => {
                this.scrollToHash(location.hash);
            });
        }
    }
}
